import React, { } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';
import useStyles from './styles/index.styles';

const VideoPopup = ({ isOpen, videoUrl, onClose }) => {
  const classes = useStyles();

   return (<Dialog
      open={isOpen}
      onClose={onClose}
      className={classes.videoDialog}
   >
      <DialogContent>
         <Box>
         <Box className={classes.iframeWrapper}>
            <iframe title='audio' style={{ display: 'block', background: 'none', border: 'none'}} width='600px' height='350px' src={videoUrl} />
         </Box>
         </Box>
      </DialogContent>
      <DialogActions>
         <Box >
         <Button
            onClick={onClose}
            style={{ color: '#fff' }}
         >
            Close
         </Button>
         </Box>
      </DialogActions>
   </Dialog>
)};

VideoPopup.propTypes = {
   isOpen: PropTypes.bool,
   videoUrl: PropTypes.string,
   onClose: PropTypes.func,
};

VideoPopup.defaultProps = {
   isOpen: false,
   videoUrl: '',
   onClose: null,
};

export default VideoPopup;